import TableBody from './table-body/table-body';
import TableContainer from 'table/table-container/table-container';
import TableRow from 'table/table-row/table-row';
import TableColumn from 'table/table-column/table-column';
import TableHeaderRow from 'table/table-header-row/table-header-row';
import TableHeaderColumn from 'table/table-header-column/table-header-column';
import TableHeader from 'table/table-header/table-header';

module.exports = {
  container: TableContainer,
  header: TableHeader,
  headerRow: TableHeaderRow,
  headerColumn: TableHeaderColumn,
  body: TableBody,
  row: TableRow,
  column: TableColumn
};


/** WEBPACK FOOTER **
 ** ./src/table/export.js
 **/